<template>
    <div class="item">
        <div class="item-with-options">
            <span class="label">{{ i18n.t("label_language") }}</span>
            <a class="hover-effect item-options-btn"
               :class="{deactive:i18n.locale.value==='en'}"
               href="#"
               @click.prevent="changeLang('zh')"
            >
                                <span class="tick"
                                      v-show="i18n.locale.value === 'zh'"
                                >
                                </span> {{ i18n.t("label_zh")}}
            </a>
            <a class="hover-effect item-options-btn"
               :class="{deactive:i18n.locale.value==='zh'}"
               href="#"
               @click.prevent="changeLang('en')"
            >
                                <span class="tick"
                                      v-show="i18n.locale.value === 'en'"
                                >
                                </span>
                {{ i18n.t("label_en")}}
            </a>
        </div>
    </div>
</template>

<script>

    import {inject} from "vue"
    import {changeLang} from "@/modules/i18n/i18n";
    import config from "@/config/config.json";

    export default {
        setup(props, context) {

            const i18n = inject('i18n');

            return {
                i18n,
                config,
                changeLang
            }
        }

    }
</script>

<style scoped lang="scss">

</style>